<template>
  <v-dialog
    :attach="Object.keys(chat).length > 0 ? 'chat-center-container' : null"
    content-class="chat-modal"
    persistent
    :value="show"
    max-width="780px">
    <div class="position-relative h-100">
      <div class="position-absolute btn-close-container">
        <v-btn icon color="white" @click="closeModal">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </div>
      <v-card tile class="h-100" :class="{ 'editor-open': showEmailEditor === true }">
        <v-toolbar card class="transparent py-4">
          <v-avatar
            size="50px"
            color="k-orange-linear">
            <h2 class="avatar-text">
              {{ chat | getName | firstChar }}
            </h2>
          </v-avatar>
          <v-toolbar-title>
            <v-layout row wrap>
              <v-flex xs12>
                <h2>
                  {{ chat | getName }}
                </h2>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <small class="small mr-3">
                Contacto: {{ chat.internal_id }}
              </small>
              <template v-if="hasCustomer">
                <small class="small mr-3">
                  Cuenta: {{ (chat.customer || {}).account || 'Sin especificar' }}
                </small>
                <small class="small">
                  RUT/DNI/CI: {{ (chat.customer || {}).fiscal_id || 'Sin especificar' }}
                </small>
              </template>
            </v-layout>
            <v-layout row wrap>
              <v-flex>
                <small class="small mr-3">
                  Intención: {{ chat.intention_id ? intention(chat.intention_id).name : 'Sin intención' }}
                </small>
              </v-flex>
              <v-flex>
                <small class="small mr-3">
                  Estado: {{ (chat.customer || {}).customer_status_id ? customerStatus(chat.customer.customer_status_id).status : 'Sin información' }}
                </small>
              </v-flex>
              <v-flex>
                <small class="small mr-3">
                  Sub-estado: {{ (chat.customer || {}).sub_status_id ? subStatus(chat.customer.sub_status_id).name : 'Sin información' }}
                </small>
              </v-flex>
            </v-layout>
            <v-layout v-if="chat.channel_id === 7" row wrap>
              <v-flex>
                <small class="small mr-3">
                  Teléfono de la empresa: {{ companyPhone }}
                </small>
              </v-flex>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="chat.global_inbox"
            class="mx-0"
            icon
            flat
            depressed
            large
            @click="showAssignChat = true"
          >
            <img src="../../assets/img/assign-chat-icon.svg" height="22" width="22" />
          </v-btn>
          <v-menu
            v-if="hasCustomer && !chat.customer.watchlist"
            v-model="showCustomerTrackingForm"
            :close-on-content-click="false"
            :nudge-left="300"
            bottom
            offset-y
          >
            <v-btn class="mx-0" slot="activator" icon flat depressed large>
              <v-icon>fa-star</v-icon>
            </v-btn>
            <customer-tracking-form
              v-model="showCustomerTrackingForm"
              :dark="false"
              :customer-id="chat.customer.id"
              :channel-id="chat.channel_id"
              :contact="chat.internal_id"
              @save="setCustomerWatchlist(1)"
            />
          </v-menu>
          <customer-tracking-indicator v-else-if="hasCustomer && chat.customer.watchlist" class="mx-0" />
          <v-menu bottom offset-y v-if="!creating || [7,1].includes(chat.channel_id)">
            <v-btn class="mx-0" slot="activator" icon flat depressed large>
              <v-icon>fa-cog</v-icon>
            </v-btn>
            <v-list class="pa-0">
              <v-list-tile @click="attach" v-if="[7,1].includes(chat.channel_id)">
                <v-list-tile-title>
                  Adjuntar archivo
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="!creating" @click="reassign(chat.id)">
                <v-list-tile-title>
                  Reasignar
                </v-list-tile-title>
              </v-list-tile>
              <!-- <v-list-tile v-if="chat.customer && chat.channel_id !== 14" @click="confirm(chat.id, 'wrongPerson')">
                <v-list-tile-title>
                  Equivocado
                </v-list-tile-title>
              </v-list-tile> -->
              <v-list-tile v-if="chat.id && canDownload" @click="downloadConversation(chat.id)">
                <v-list-tile-title>
                  Descargar conversación
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                v-if="chat.id && canDownload && [1, 7].includes(chat.channel_id)"
                :disabled="loadingPdf"
                @click="downloadConversationPdf(chat.id)">
                <v-list-tile-title>
                  Descargar conversación PDF
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="chat.id && canSendChat" @click="openSendConversationModal(chat.id)">
                <v-list-tile-title>
                  Enviar conversación
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn class="ml-0" icon flat depressed large v-if="hasCustomer && !creating" @click="$emit('edit')">
            <v-icon>fa-pen</v-icon>
          </v-btn>
          <v-btn class="ml-0" icon flat depressed large v-if="!hasCustomer" @click="assign">
            <v-icon>fa-user-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="tabs-container px-0 pb-0">
          <v-tabs
            grow
            color="transparent"
            class="border-top border-bottom"
            v-model="tab">
            <v-tabs-slider color="k-orange-linear"></v-tabs-slider>
            <v-tab href="#tab-1">
              <v-icon small class="k-orange-linear-text mr-1">fa-comment</v-icon> <small>Chat</small>
            </v-tab>
            <v-tab href="#tab-2">
              <v-icon small class="k-orange-linear-text mr-1">fa-info-circle</v-icon> <small>Información</small>
            </v-tab>
            <v-tab href="#tab-3">
              <v-icon small class="k-orange-linear-text mr-1">fa-clipboard-list</v-icon> <small>Gestiones</small>
            </v-tab>
            <v-tab href="#tab-4">
              <v-icon small class="k-orange-linear-text mr-1">fa-tasks</v-icon> <small>{{ dueName }}</small>
            </v-tab>
            <v-tab href="#tab-5">
              <v-icon small class="k-orange-linear-text mr-1">fa-hand-holding-usd</v-icon> <small>Pagos</small>
            </v-tab>
            <v-tab href="#tab-6">
              <v-icon small class="k-orange-linear-text mr-1">fa-list</v-icon> <small>Seguimientos</small>
            </v-tab>
            <v-tab href="#tab-7">
              <v-icon small class="k-orange-linear-text mr-1">fa-file-alt</v-icon> <small>Convenios</small>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item id="tab-1">
              <chat
                :creating="creating"
                :chat="chat"
                v-if="chat.chat_center_messages"
                :text-field-size="textFieldSize"
                :show-email-editor="showEmailEditor"
                :update-chat-scrollbar="updateChatScrollbar"
                @click.native="closeEmailEditor"
                @mark-solved="markSolved"
                @scrollbarUpdated="updateChatScrollbar = false">
              </chat>
              <droppable-file
                v-if="[7,1].includes(chat.channel_id) && !hideDroppableForWhatsappExpired"
                :chat="chat"
                :text="form.text"
                :form="form"
                :creating="creating"
                @show-set-email="showSetEmail = true"
                @appendMessagesToChat="appendFile">
              </droppable-file>
              <v-card-actions
                v-if="tab === 'tab-1'"
                class="white py-0 px-0 position-relative">
                <v-container fluid ma-0 pa-0 v-if="showEmailEditor">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <vue-editor
                        ref="editor"
                        v-model="form.text"
                        placeholder="Escribe un mensaje..."
                        useCustomImageHandler
                        @imageAdded="handleImageAdded"
                        :editorToolbar="editorToolbar"
                      ></vue-editor>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap py-2 px-2>
                    <v-flex md1 text-xs-left>
                      <v-tooltip right>
                        <v-btn icon @click="answerTemplates()" slot="activator">
                          <v-icon class="k-blue-linear-text">fas fa-comment</v-icon>
                        </v-btn>
                        <span>Respuestas predefinidas</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs9 class="d-flex aling-center">
                      <template v-if="hasFiles">
                        <small class="d-flex align-center box text-truncate mr-1" v-for="(file, index) in answerTemplate.files" :key="`file-item-${index}`">
                          {{ file.original_name }}
                        </small>
                      </template>
                    </v-flex>
                    <v-flex md2 text-xs-right>
                      <v-btn color="k-blue-linear" class="mr-0" @click="sendMessage()">Enviar</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
                <template v-else>
                  <template v-if="whatsappInputLocked">
                    <v-layout row wrap align-center class="whatsapp-expired-notice py-2 px-2 ma-0">
                      <v-flex xs2 sm1 class="text-xs-center">
                        <v-tooltip right>
                          <v-btn
                            icon
                            slot="activator"
                            class="ma-0"
                            :disabled="quickReplyDisabled || sendingWhatsappTemplate"
                            :loading="sendingWhatsappTemplate"
                            @click="openWhatsappTemplatesModal"
                          >
                            <v-icon class="k-blue-linear-text">fas fa-comment</v-icon>
                          </v-btn>
                          <span>Plantillas de WhatsApp</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs1 class="text-xs-center px-0">
                        <v-icon class="grey--text">fas fa-lock</v-icon>
                      </v-flex>
                      <v-flex xs9 sm10 class="whatsapp-expired-text">
                        Han pasado más de 24 horas desde el último mensaje del cliente. Solo puedes responder usando una plantilla.
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else>
                    <v-tooltip right :disabled="chat.channel_id === 1">
                      <v-btn
                        icon
                        @click="answerTemplates()"
                        slot="activator"
                        :disabled="quickReplyDisabled">
                        <v-icon class="k-blue-linear-text">fas fa-comment</v-icon>
                      </v-btn>
                      <span>Respuestas predefinidas</span>
                    </v-tooltip>
                    <v-text-field
                      ref="messageField"
                      id="messageField"
                      v-on="chat.channel_id === 1 ? { click: () => answer() } : {}"
                      v-model="chat.channel_id === 1 ? textWithoutTagPre(form.text) : form.text"
                      append-icon="send"
                      :append-icon-cb="sendMessage"
                      label="Escribe un mensaje..."
                      @keypress.enter.exact.prevent="sendMessage()"
                      :multi-line="chat.channel_id !== 1 ? true : null"
                      :auto-grow="chat.channel_id !== 1 ? true : null"
                      :rows="1"
                      :class="{ textarea: chat.channel_id !== 1,'pa-0 campito': true}"
                      :hide-details="true"
                      flat
                      solo
                      :readonly="chat.channel_id === 1"
                      :disabled="quickReplyDisabled || (chat.chat_center_status_id === 7 && chat.channel_id === 7)"
                      @input="getTextboxSize">
                      <v-icon slot="append-icon">send</v-icon>
                    </v-text-field>
                    <small
                      v-if="chat.channel_id === 2"
                      :class="{
                        'k-orange-linear-text': form.text.length > maxChars,
                      }">{{ form.text.length }} / {{ maxChars }}</small>
                  </template>
                </template>
              </v-card-actions>
            </v-tab-item>
            <v-tab-item id="tab-2">
              <customer-info
                :tab="tab"
                :customer="chat.customer"
                :from-chat-center="fromChatCenter"
                v-if="hasCustomer"
                @customerLoaded="customerLoaded">
              </customer-info>
              <info v-else>
              </info>
            </v-tab-item>
            <v-tab-item id="tab-3">
              <customer-movements :tab="tab" v-if="hasCustomer" :customer="chat.customer" :from-chat-center="fromChatCenter">
              </customer-movements>
              <info v-else>
              </info>
            </v-tab-item>
            <v-tab-item id="tab-4">
              <customer-dues :tab="tab" v-if="hasCustomer" :customer="chat.customer">
              </customer-dues>
              <info v-else>
              </info>
            </v-tab-item>
            <v-tab-item id="tab-5">
              <customer-payments :tab="tab" v-if="hasCustomer" :customer="chat.customer">
              </customer-payments>
              <info v-else>
              </info>
            </v-tab-item>
            <v-tab-item id="tab-6">
              <customer-tracking-logs-tab v-if="hasCustomer" :tab="tab" :customer="chat.customer">
              </customer-tracking-logs-tab>
              <info v-else>
              </info>
            </v-tab-item>
            <v-tab-item id="tab-7">
              <agreements-tab
                v-if="hasCustomer"
                :key="`agreements-${chat.customer.id}`"
                :tab="tab"
                :customer="chat.customer">
              </agreements-tab>
              <info v-else>
              </info>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </div>
    <assign-chat-modal
      :show="showAssignChat"
      :chat-center-id="chat.id"
      :companies="companies"
      @save="assignChatCompany"
      @changeValue="showAssignChat = $event">
    </assign-chat-modal>
    <whatsapp-templates-chat-modal
      :show.sync="showWhatsappTemplatesModal"
      :sending="sendingWhatsappTemplate"
      :chat="chat"
      :has-customer="hasCustomer"
      @submit="onWhatsappTemplateSubmit"
    />
    <assign-dialog :chatCenterId="chat.id" :showFiscal="showFiscal" @changeValue="showFiscal = $event"></assign-dialog>
    <duplicate-modal
      @changeValue="showDuplicateModal = $event"
      :show="showDuplicateModal"
      @deleted="replaceChat"
      :chatCenter="chat">
    </duplicate-modal>
    <email-select :show="showSetEmail" @changeValue="showSetEmail = $event" @save="setEmail"></email-select>
    <v-snackbar
      :bottom="true"
      v-model="snackbar">
      El sms tiene un maximo de {{ maxChars }} caracteres y no poseer caracteres especiales.
      <v-btn flat color="#ff7c64 " @click.native="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-dialog>
</template>
<script>
/* eslint-disable */
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { VueEditor } from 'vue2-editor';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EventBus from '@/event-bus';
import Info from '@/components/global/Info';
import permissionsMixin from '@/mixins/permissions';
import ChannelMixins from '@/mixins/channelsV2';
import chatCenterMixin from '@/mixins/chatCenterMixin';
import DroppableFile from '@/components/global/DroppableFile';
import CustomerInfo from '@/components/customer/CustomerInfo';
import CustomerDues from '@/components/customer/CustomerDues';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';
import EmailSelect from '@/components/company_email/SetEmailSubject';
import CustomerPayments from '@/components/customer/CustomerPayments';
import CustomerMovements from '@/components/customer/CustomerMovements';
import AssignDialog from './AssignDialog';
import DuplicateModal from './DuplicateModal';
import ModalBtn from './ModalBtn';
import Chat from './Chat';
import CustomerTrackingForm from '@/components/customer/CustomerTrackingForm';
import CustomerTrackingIndicator from '@/components/customer/CustomerTrackingIndicator';
import CustomerTrackingLogsTab from './CustomerTrackingLogsTab';
import AssignChatModal from './AssignChatModal';
import WhatsappTemplatesChatModal from './WhatsappTemplatesChatModal';
import AgreementsTab from '@/components/agreements/AgreementsTab';

const uuidv1 = require('uuid/v1');

export default {
  mixins: [
    permissionsMixin,
    emailEditorToolbarMixin,
    chatCenterMixin,
    ChannelMixins,
  ],
  components: {
    CustomerTrackingIndicator,
    CustomerTrackingLogsTab,
    CustomerTrackingForm,
    VuePerfectScrollbar,
    CustomerMovements,
    CustomerPayments,
    AssignChatModal,
    WhatsappTemplatesChatModal,
    DuplicateModal,
    DroppableFile,
    CustomerInfo,
    CustomerDues,
    AgreementsTab,
    AssignDialog,
    EmailSelect,
    VueEditor,
    ModalBtn,
    Info,
    Chat,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    chat: {
      type: Object,
      default: () => {},
    },
    hasCustomer: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    creating: {
      type: Boolean,
      default: false,
    },
    answerTemplate: {
      type: Object,
      default: () => ({}),
    },
    fromChatCenter: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$store.commit('SET_DRAG', false);
    EventBus.$on('applyTemplate', (text) => {
      this.form.text = text;
      if (this.chat.channel_id === 1) {
        this.showEmailEditor = true;
      }
    });
    window.addEventListener("dragenter", () => {
      this.$store.commit('SET_DRAG', true);
    });
  },
  destroy() {
    EventBus.$off('applyTemplate');
  },
  data() {
    return {
      cancelToken: this.axios.CancelToken.source(),
      tab: 'tab-1',
      form: {
        text: '',
        email: '',
        subject: '',
        template_id: null,
      },
      phone:{},
      snackbar: false,
      showDuplicateModal: false,
      showEmailEditor: false,
      updateChatScrollbar: false,
      showFiscal: false,
      showSetEmail: false,
      textFieldSize: 44,
      showCustomerTrackingForm: false,
      showAssignChat: false,
      companies: [],
      showWhatsappTemplatesModal: false,
      sendingWhatsappTemplate: false,
      loadingPdf: false,
    };
  },
  computed: {
    ...mapGetters([
      'customerStatus',
      'subStatus',
      'intention',
      'chat_center_config',
    ]),
    dueName() {
      let name = 'Cuotas';
      if (this.$auth.user().company_id === 8230622) {
        name = 'Polizas';
      }
      return name;
    },
    routeMessage() {
      let route = `chats_center/${this.chat.id}/messages`;
      if (this.creating) {
        route = `chats_center/initiate`;
      }
      return route;
    },
    hasSpecialChar() {
      return !/^[a-zA-ZñÑ0-9+~¡!@#$%^&*\-_()\[\]{};":,.\/¿?\\|= ]*$/g.test(this.form.text);
    },
    smsInvalid() {
      return this.chat.channel_id === 2 && (this.form.text.length > this.maxChars || this.hasSpecialChar);
    },
    companyPhone() {
      return !_.isEmpty(this.phone) && this.phone.company_phone != null ? (this.phone.prefix_phone ? '(+' + this.phone.prefix_phone + ') ' : '' ) + this.phone.company_phone: 'Sin información'
    },
    maxChars() {
      const { config } = (this.chat_center_config || {});
      if (Object.keys(config || {}).length) {
        return config.max_sms_char || 160;
      }
      return 160;
    },
    hasFiles() {
      return (this.answerTemplate.files || []).length
    },
    canDownload() {
      return this.checkPermissions(['download_conversation']);
    },
    canSendChat() {
      return this.checkPermissions(['send_conversation']);
    },
    /** Misma lógica que el botón de respuestas rápidas antes de esta feature. */
    quickReplyDisabled() {
      return (this.chat.disabled && this.chat.chat_center_status_id === 7)
        || this.chat.channel_id === 14;
    },
    /**
     * Ventana de 24 h desde el último mensaje del cliente (origin === 0) en este chat.
     * Sin mensajes del cliente → se considera expirado (solo plantillas). No aplica al crear chat nuevo.
     */
    whatsappSessionExpired() {
      if (!this.chat || this.chat.channel_id !== 7 || this.creating) {
        return false;
      }
      const messages = this.chat.chat_center_messages || [];
      const fromCustomer = messages.filter(m => m && Number(m.origin) === 0);
      if (!fromCustomer.length) {
        return true;
      }
      let last = fromCustomer[0];
      fromCustomer.forEach((m) => {
        if (moment.utc(m.created_at).isAfter(moment.utc(last.created_at))) {
          last = m;
        }
      });
      return moment.utc().diff(moment.utc(last.created_at), 'hours', true) >= 24;
    },
    whatsappInputLocked() {
      return this.whatsappSessionExpired;
    },
    hideDroppableForWhatsappExpired() {
      return this.chat.channel_id === 7 && this.whatsappSessionExpired && !this.creating;
    },
  },
  methods: {
    obtainCompanyPhone() {
      if (this.chat.channel_id == 7) {
        const activeChatId = this.chat.id;
         this.axios.get( `chats_center/${activeChatId}/company_phone`).then(({ data }) => {
           this.phone = _.isEmpty(data) ? {} : data;
         })
           .catch(() => {});
      }
    },
    replaceChat() {
      this.showDuplicateModal = false;
      this.closeModal();
      this.chat.chat_center_status_id = 0;
    },
    closeEmailEditor() {
      this.showEmailEditor = false;
    },
    closeModal() {
      this.form.text = '';
      this.showEmailEditor = false;
      this.$emit('close', this.chat.id);
    },
    customerLoaded($event) {
      this.chat.customer = $event;
    },
    answer() {
      if (this.chat.channel_id === 1) {
        this.showEmailEditor = true;
      }
    },
    answerTemplates() {
      this.$emit('openAnswerTemplates', this.chat.channel_id);
      EventBus.$emit('openAnswerTemplates', this.chat.channel_id);
    },
    openWhatsappTemplatesModal() {
      if (this.quickReplyDisabled || this.sendingWhatsappTemplate) {
        return;
      }
      this.showWhatsappTemplatesModal = true;
    },
    onWhatsappTemplateSubmit(payload) {
      if (this.quickReplyDisabled || this.sendingWhatsappTemplate) {
        return;
      }
      const identifier = uuidv1();
      const textSend = this.textWithoutTagPre(payload.resolved_text || '');
      if (!textSend) {
        EventBus.$emit('modal', 'No hay texto para enviar.');
        return;
      }
      const message = {
        identifier,
        chat_center_id: this.chat.id,
        origin: 1,
        type: 'message',
        text: textSend,
        status: 'Pendiente',
        created_at: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        user: {
          first_name: this.$auth.user().first_name,
          last_name: this.$auth.user().last_name,
        },
      };
      this.updateChatScrollbar = true;
      this.$emit('appendMessagesToChat', message);
      this.sendingWhatsappTemplate = true;
      this.axios.post(this.routeMessage, {
        text: textSend,
        identifier,
        whatsapp_template_id: payload.whatsapp_template_id,
        variable_values: payload.variable_values || {},
      }, {
        headers: {
          'X-Socket-ID': window.Echo.socketId(),
        },
      }).then(({ data }) => {
        this.showWhatsappTemplatesModal = false;
        this.$emit('updateSendedMessage', {
          id: data.chat_center_message.chat_center_id,
          identifier: data.identifier,
          chatCenterMessage: data.chat_center_message,
        });
        this.$emit('updateActiveChat', {
          id: data.chat_center_message.chat_center_id,
          chat_center_status_id: 5,
          unread_messages: 0,
        });
      }).catch((error) => {
        const res = (error.response && error.response.data) ? error.response.data : {};
        const inner = res.data || res;
        const errors = inner.errors || {};
        let msg = 'Ocurrió un error al enviar la plantilla. Intentá nuevamente.';
        if (errors.whatsapp_template && errors.whatsapp_template[0]) {
          msg = errors.whatsapp_template[0];
        } else if (errors.whatsapp_template_id && errors.whatsapp_template_id[0]) {
          msg = errors.whatsapp_template_id[0];
        } else if (errors.message && errors.message[0]) {
          msg = errors.message[0];
        } else if (inner.message) {
          msg = inner.message;
        }
        EventBus.$emit('modal', msg);
        const messages = this.chat.chat_center_messages;
        const idx = messages.findIndex(item => item.identifier === identifier);
        if (idx !== -1) {
          messages[idx].status = 'Error';
          this.$emit('updateSendedMessage', {
            id: this.chat.id,
            identifier,
            chatCenterMessage: messages[idx],
          });
        }
      }).finally(() => {
        this.sendingWhatsappTemplate = false;
      });
    },
    setEmail(email) {
      this.form = {
        ...this.form,
        ...email,
      };
      this.sendMessage();
    },
    sendMessage() {
      if (!this.form.text) {
        EventBus.$emit('modal', 'Escriba un mensaje');
      } else {
        let textSend = this.textWithoutTagPre(this.form.text);
        if (this.creating && this.chat.channel_id === 1 && (!this.form.subject || !this.form.email)) {
          this.showSetEmail = true;
          this.$store.commit('SET_DRAG', false);
          return;
        }
        if (this.smsInvalid) {
          this.snackbar = true;
          return;
        }
        const message = {
          identifier: uuidv1(),
          chat_center_id: this.chat.id,
          origin: 1,
          type: 'message',
          text: textSend,
          status: 'Pendiente',
          created_at: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
          user: {
            first_name: this.$auth.user().first_name,
            last_name: this.$auth.user().last_name,
          },
          template_id: this.form.template_id,
          files: this.answerTemplate.files,
        };
        let obj = {
          text: message.text,
          identifier: message.identifier,
          template_id: message.template_id,
        };
        if (this.creating) {
          const chat = _.pick(this.chat, ['customer', 'internal_id', 'channel_id', 'contact_id']);
          chat.customer = _.pick(chat.customer, ['id']);
          obj.chatCenter = JSON.stringify(chat);
          obj.email = this.form.email;
          obj.subject = this.form.subject;
          if (this.chat.chat_center_messages.length < 1) {
            this.chat.fetch_messages = false;
          }
        }
        this.updateChatScrollbar = true;
        this.$emit('appendMessagesToChat', message);
        this.axios.post(this.routeMessage, {
          ...obj,
        }, {
          headers: {
            'X-Socket-ID': window.Echo.socketId(),
          },
        }).then(({ data }) => {
          if (this.creating && this.chat.channel_id === 1) {
            this.$emit('reload-message', this.chat.id, {
              ...JSON.parse(obj.chatCenter),
              subject: obj.subject,
              company_id: this.chat.company_id,
              id: data.chat_center_message.chat_center_id,
            });
          }
          // eslint-disable-next-line
          this.$emit('updateSendedMessage', {
            id: data.chat_center_message.chat_center_id,
            identifier: data.identifier,
            chatCenterMessage: data.chat_center_message,
          });
          this.$emit('updateActiveChat', {
            id: data.chat_center_message.chat_center_id,
            chat_center_status_id: 5,
            unread_messages: 0,
          });
        }).catch((error) => {
          const {data} = error.response.data;
          console.log('ERROR: ', data);

          if(data.errors){
            const errorMsg = data.errors.message[0];
            console.log(data.errors);
            EventBus.$emit('modal', errorMsg);
          }else{
            EventBus.$emit('modal', 'Ocurrio un error, por favor intente nuevamente.');
          }

          const messages = this.chat.chat_center_messages;
          const identifier = data.identifier;
          const index = messages.findIndex(item => item.identifier === identifier);
          if (index !== -1) {
            messages[index].status = 'Error';
            this.$emit('updateSendedMessage', {
              id: this.chat.id,
              identifier,
              chatCenterMessage: messages[index],
            });
          }
        });
        this.form.text = '';
      }
    },
    assign() {
      this.showFiscal = true;
    },
    markSolved({ chatCenterId, delete_chat, showAlert }) {
      this.$emit('mark-solved', chatCenterId);
      if (showAlert) {
        this.$emit('show-alert')
      }
      if (delete_chat) {
        this.showDuplicateModal = true;
      }
    },
    reassign(id) {
      this.$emit('reasign', id);
    },
    confirm(id, type) {
      EventBus.$emit('openConfirmDialog', id, type);
    },
    downloadConversation(id) {
      this.axios.get(`chat_centers/${id}/descargar-conversacion`).then(({ data }) => {
        this.forceFileDownload(data);
      });
    },
    downloadConversationPdf(id) {
      this.loadingPdf = true;

      this.axios.get(`chat_centers/${id}/descargar-conversacion-pdf`)
        .then(({ data }) => {
          if (!data.signedUrl) {
            throw new Error('Respuesta inválida del servidor');
          }
          window.open(data.signedUrl, '_blank');
        })
        .catch((error) => {
          const res = (error.response && error.response.data) ? error.response.data : {};
          const message = res.error || error.message || 'No se pudo generar el PDF';
          EventBus.$emit('modal', message);
        })
        .finally(() => {
          this.loadingPdf = false;
        });
    },
    ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    forceFileDownload(data) {
      const channel = (this.channels.find(x => x.id === this.chat.channel_id) || {});
      const username = this.getChatUserName(this.chat);
      const fileName = `${channel.text} ${username} ${moment().format('DD/MM/YYYY')}`;
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.html`);
      document.body.appendChild(link);
      link.click();
    },
    getChatUserName(chat) {
      const { customer, user_name } = chat;
      if (customer) {
        const { first_name, last_name, name } = customer;
        if (name) {
          return this.ucFirst(name);
        } else if(first_name && last_name) {
          return `${this.ucFirst(first_name)} ${this.ucFirst(last_name)}`;
        } else if (first_name || last_name) {
          return this.ucFirst(first_name || last_name);
        } else if (user_name) {
          return this.ucFirst(user_name);
        }
        return 'Desconocido';
      }
      if (user_name) {
        return this.ucFirst(user_name);
      }
      return 'Desconocido';
    },
    attach() {
      this.$store.commit('SET_DRAG', true);
    },
    getTextboxSize() {
      if (this.$refs.messageField) {
        setTimeout(() => {
          const height = this.$refs.messageField.$el.clientHeight;
          this.textFieldSize = height;
          this.updateChatScrollbar = true;
          this.$forceUpdate();
        }, 50);
      }
      if (this.form.text === '') {
        this.textFieldSize = 44;
      }
    },
    appendFile($event) {
      if (!(this.creating && this.chat.channel_id === 1 && (!this.form.subject || !this.form.email))) {
        this.$emit('appendMessagesToChat', $event);
      }
    },
    openSendConversationModal(id) {
      this.$emit('open-send-conversation', id);
    },
    removeScripts(provisoryHTML) {
      let elementsFound = false;
      let provisoryHTMLCopy = provisoryHTML;
      const htmlWitoutScripts = provisoryHTMLCopy.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');

      const htmlWitoutScriptsV2 = htmlWitoutScripts.replace(/<script\b[^>]*\/>/gi, '');

      const htmlWitoutScriptsV3 = htmlWitoutScriptsV2.replace(/\s+(\w+-\w+)\s*=\s*(["'])[^"']*\.js\2/gi, '');

      const htmlWitoutEvents = htmlWitoutScriptsV3.replace(/(\s+on\w+\s*=\s*(['"])(.*?)\2)/gi, '');

      const htmlWitoutHrefJS = htmlWitoutEvents.replace(/href\s*=\s*["']?javascript:[^"']*["']?/gi, '');

      provisoryHTMLCopy = htmlWitoutHrefJS;
      elementsFound = provisoryHTML !== provisoryHTMLCopy ? true : false;
      return provisoryHTMLCopy;
    },
    textWithoutTagPre(text) {
      const parser = new DOMParser();
      const matches = text.match(/<pre[^>]*>[\s\S]*?<\/pre>/g) || []; // Obtener todas las coincidencias

      let result = text;

      for (const match of matches) {
        const tagPreContent = match.match(/<pre[^>]*>([\s\S]*?)<\/pre>/)[1] || '';
        const documentHTML = parser.parseFromString(tagPreContent, 'text/html').body.textContent;
        result = result.replace(match, documentHTML); // Reemplazar cada coincidencia en el resultado
      }
      return this.removeScripts(result);
    },
    setCustomerWatchlist($event) {
      this.$set(this.chat.customer, 'watchlist', $event);
    },
    assignChatCompany(chatId) {
      this.showAssignChat = false;
      this.$emit('assign-chat-company');
      this.closeModal();
    },
  },
  watch: {
    'form.text' () {
      this.getTextboxSize();
    },
    hasCustomer: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.chat) {
          this.obtainCompanyPhone();
        }
      }
    },
    showEmailEditor(newVal) {
      if (newVal) {
        if (this.user.email_signature) {
          this.form.text += `<br><br>${this.user.email_signature}<br>`;
        }
        this.updateChatScrollbar = true;
        setTimeout(() => {
          document.getElementsByClassName('ql-editor')[0].focus();
        }, 200);
      } else {
        this.form.text = '';
        this.form.template_id = '';
      }
    },
    answerTemplate: {
      deep: true,
      handler() {
        this.form.text = this.answerTemplate.text;
        this.form.template_id = this.answerTemplate.id;
        if (this.chat.channel_id === 1) {
          this.showEmailEditor = true;
        }

      },
    },
    show: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && this.chat.global_inbox) {
          this.axios.get('filters/companies').then(({ data }) => {
            this.companies = data;
          });
        }
      }
    },
  },
};
</script>
<style scoped>
  .small {
    font-size: 12px;
  }
  .avatar-text {
    font-size: 28px;
  }
  .border-top {
    border-top: 1px solid #d3d3d3;
  }
  .border-left {
    border-left: 1px solid #d3d3d3;
  }
  .border-bottom {
    border-bottom: 1px solid #d3d3d3;
  }
  .tabs__div:not(:last-child) {
    border-right: 1px solid #d3d3d3;
  }
  .card__actions .textarea {
    overflow: hidden;
  }
  .card__actions .textarea >>> .input-group__input {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .card__actions .textarea >>> textarea {
    height: initial;
    max-height: 168px;
    position: relative !important;
    background-image: none !important;
    transition: all .25s linear;
  }
  .chat-room .quillWrapper {
    height: 232px;
  }
  .chat-room .quillWrapper {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
  }
  .position-relative {
    position: relative;
  }
  .position-absolute {
    position: absolute;
  }
  .btn-close-container {
    z-index: 1;
    top: -25px;
    right: -25px;
    position: absolute;
  }
  .btn-close-container  >>> .btn__content {
    border: 3px solid #f57a63;
  }

  .quillWrapper >>> .ql-editor {
    height: 150px;
    font-size: 16px;
    min-height: 150px;
    overflow-y: scroll;
  }

  .customer-tracking-form--offset {
    position: absolute;
    left: 0;
    z-index: 9999;
    bottom: -340px;
  }
  .box {
    color: #404040;
    width: 200px;
    border: 1px solid #CCCCCC;
    padding: .5em;
    border-radius: 2px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
  }
  .whatsapp-expired-notice {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 8px 12px;
    background: #f5f5f5;
    border-radius: 4px;
    margin-right: 8px;
    width: 100%;
  }
  .whatsapp-expired-text {
    font-size: 13px;
    color: #757575;
    flex: 1;
    line-height: 1.4;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/ChatRoom.vue